import React from "react";
import PropTypes from "prop-types";
import { CalendarTemplate } from 'themes/application/schedule/components';
import { CalendarStore } from 'application/schedule/stores';
import { observer } from 'mobx-react';

@observer
class Calendar extends React.Component {
    render() {
        return <CalendarTemplate {...this.props} />;
    }
}

Calendar.propTypes = {
    store: PropTypes.instanceOf(CalendarStore)
};

export default Calendar;
